import { StyleSheet } from "../../../platformComponents";
import {
  alignItems,
  colors,
  flexDirection,
  fontFamily,
  fontSize,
  justifyContent,
  margin,
  padding,
  radius,
} from "../../../styles/common";
import { IS_WEB, tranformPx } from "@adgm/libs";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  card: {
    marginBottom: margin.m12,
    borderWidth: 1,
    borderColor: colors.borderColor2,
    overflow: "hidden",
  },

  emptyCard: {
    borderRadius: radius.r8,
    marginBottom: margin.m12,
    borderWidth: 1,
    borderColor: colors.borderColor2,
    opacity: 0.3,
    paddingVertical: padding.p20,
    alignItems: "center",
    justifyContent: "center",
  },

  cardContent: {
    paddingTop: padding.p16,
    paddingHorizontal: padding.p16,
    borderBottomWidth: 1,
    borderColor: colors.textInputBorderColor,
  },

  fieldRow: {
    flexDirection: flexDirection.row,
    alignItems: alignItems.center,
    justifyContent: justifyContent.spaceBetween,
    marginBottom: margin.m20,
  },

  fieldLabel: {
    fontFamily: IS_WEB ? "Common-Regular" : fontFamily.commonRegular,
    fontSize: fontSize.f12,
    color: IS_WEB ? colors.white17 : colors.white,
    marginBottom: margin.m4,
    flexWrap: "wrap",
    maxWidth: tranformPx(160),
  },

  fieldValue: {
    minHeight: tranformPx(20),
    justifyContent: "center",
    flex: 1,
  },

  fieldValueText: {
    fontFamily: IS_WEB ? "Common-Regular" : fontFamily.commonRegular,
    fontSize: fontSize.f14,
    color: IS_WEB ? colors.white17 : colors.white,
    lineHeight: tranformPx(20),
  },

  emptyText: {
    fontFamily: IS_WEB ? "Common-Regular" : fontFamily.commonRegular,
    fontSize: fontSize.f14,
    color: colors.TextColor5,
    textAlign: "center",
  },

  actionContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingRight: padding.p8,
    paddingVertical: padding.p12,
  },

  actionButton: {
    width: tranformPx(32),
    height: tranformPx(32),
    alignItems: "center",
    justifyContent: "center",
    marginLeft: margin.m8,
  },

  actionIcon: {
    width: tranformPx(16),
    height: tranformPx(16),
    tintColor: colors.mainTextColor,
  },

  addButton: {
    marginTop: margin.m16,
    height: tranformPx(44),
    borderColor: colors.highlightColor,
  },

  // 国籍显示相关样式
  nationalityContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    flexWrap: "wrap",
  },

  nationalityFlag: {
    width: tranformPx(14),
    height: tranformPx(12),
    marginRight: margin.m6,
    borderRadius: radius.r2,
  },

  nationalityText: {
    fontFamily: IS_WEB ? "Common-Regular" : fontFamily.commonRegular,
    fontSize: fontSize.f14,
    color: IS_WEB ? colors.white17 : colors.white,
    flex: 1,
    maxWidth: tranformPx(200),
    textAlign: "right",
  },

  // 百分比样式
  percentageText: {
    fontFamily: IS_WEB ? "Common-Regular" : fontFamily.commonRegular,
    fontSize: fontSize.f14,
    color: IS_WEB ? colors.white17 : colors.white,
  },
});
